import { RootState } from "../../../utils/types/root-state";

export const getBurgerIngredientsState = (state: RootState) => state.burgerIngredients;
